import { useEffect, useState } from 'react';

import { Button, Select, Form, Radio } from 'antd';

import { selectDefaultProvider, sortByIPA } from 'utils/helpers';
import { ErrorResponse, UserModel } from 'utils/types';
import notifier from 'utils/notifier';

import { getAuthEnabledProviderList, GetAuthEnabledProviderListResponse } from 'store/authorization/provider/actions';

import FloatLabel from 'components/Common/FloatLabel';

import './index.scss';

const { Option } = Select;

interface OpenAuthFormProps {
    isFetchingUnused: boolean,
    getUnusedAuths(userId: string, rptType: string, provKeyId: string): any;
    getAuthEnabledProviderList(userModel: UserModel): any;
    setUnusedAuthDataSource(data: any[]): void,
    setSelectedProvId(provId: string): void,
    setSelectedRptType(rptType: string): void,
    setProviderList(data: any[]): void,
    providerList: any[]
};

const OpenAuthForm = (props: OpenAuthFormProps) => {
  const [form] = Form.useForm();
  const [provider, setProvider] = useState(Object);
  const [rptType, setRptType] = useState('');

  const authEnabledProviderListParam = {
    UserId: sessionStorage.user_id,
    UserRole: sessionStorage.user_role
  };

  useEffect(() => {
    props.getAuthEnabledProviderList(authEnabledProviderListParam)
    .then((response: GetAuthEnabledProviderListResponse) => {
      props.setProviderList(sortByIPA(response, 'Provider'))
    })
    .catch((err: ErrorResponse) => {
        notifier.error(err.response?.data.Message || 'Something went wrong, please contact a system administrator.');
    });

  }, []);

  const onSearch = () => {
    form.validateFields().then(values => {

      return props.getUnusedAuths(sessionStorage.getItem('user_id')!, rptType, JSON.parse(provider).RmiProvKeyId)
        .then((response: any) => {
          if (response.length === 0) notifier.info('No open authorizations found for this provider.');
          props.setSelectedProvId(JSON.parse(provider).RmiProvId);
          props.setSelectedRptType(rptType);
          props.setUnusedAuthDataSource(response);
        })
        .catch((err: ErrorResponse) => {
          notifier.error(err?.response?.data?.Message || 'Something went wrong, please contact a system administrator.');
        });
    })
  };

  const onReset = () => {
    props.setUnusedAuthDataSource([]);
    form.resetFields();
  };

  return (
    <Form
      form={form}
      name={'openSearchForm'}
      onFinish={onSearch}
    >
        <div className="member-search row flex-lg-wrap justify-content-start mb-3 ml-0">
        <div className="col-lg-4" style={{ display: "flex", alignItems: "center" }}>
          <Form.Item
            name="rptType"
            rules={[
              { required: true, message: 'Required' }
            ]}
          >
            <Radio.Group onChange={e => setRptType(e.target.value)} value={rptType}>
              <Radio value={"PCP"}>PCP</Radio>
              <Radio value={"SCP"}>SCP</Radio>
            </Radio.Group>
          </Form.Item>
        </div>
        <div className="col-lg-12">
          <FloatLabel
              label="Provider:"
              name="provider"
              form={form}
              value={provider}
              required
          >
              <Select
                  showSearch
                  value={provider}
                  placeholder="Select a Provider..."
                  onChange={value => setProvider(value)}
                  loading={props.isFetchingUnused}
              >
                  {props.providerList.map((option: any, key: number) => {
                      return <Option key={key} value={JSON.stringify(option)}>{option.Provider}</Option>;
                  })}
              </Select>
          </FloatLabel>
        </div>
        <div className="col-lg-2 mt-2"></div>
        <div className="col-lg-6 mt-2">
            <Form.Item>
            <div className="d-flex justify-content-end">
                <Button type="primary" style={{ width: "50%" }} htmlType={'submit'} loading={props.isFetchingUnused}>SEARCH</Button>
                <Button type="default" style={{ width: "50%" }} onClick={onReset}>RESET</Button>
            </div>
            </Form.Item>
        </div>
    </div>
    </Form>
  );
}

export default OpenAuthForm;